import PropTypes from "prop-types"
import React from "react"
import { RouterProvider, createHashRouter } from "react-router-dom"

import MeteredElectricForm from "./MeteredElectricForm"
import MeteredElectricView from "./MeteredElectricView"

const MeteredElectricContainer = ({ useNewTaxExperience }) => {
  const router = createHashRouter([
    {
      path: "/",
      element: (
        <MeteredElectricView useNewTaxExperience={useNewTaxExperience} />
      ),
      children: [
        {
          path: "meters/:id/metered_electrics/new",
          element: <MeteredElectricForm />,
        },
      ],
    },
  ])

  return <RouterProvider router={router} />
}

MeteredElectricContainer.propTypes = {
  useNewTaxExperience: PropTypes.bool.isRequired,
}

export default MeteredElectricContainer
